import { render } from "./AppFooter.vue?vue&type=template&id=7691f71f&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=7691f71f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7691f71f"]])

export default __exports__